import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Link,
  CircularProgress,
  Box,
} from "@material-ui/core";
import StudentGradesRecord from "./studentGradesRecord";
import UpdateNotices from "./updateNotices";
import ClassNotices from "./classNotices";
import DegreeCourses from "./degreeCourses";
import CourseGroups from "./courseGroups";

import TermSummary from "./termSummary";
import RequiredCourses from "./requiredCourses";
import SuccessProgress from "./SuccessProgress";
import TermGrades from "./TermGrades";
import OpenCourses from "./openCourses";
import DegreePlan from "../Students/DegreePlan";

const StudentDashboard = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const studentId = useSelector((state) => state.login?.user?.studentId);

  const handleCourseClick = (course) => {
    setSelectedCourse(course.course);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedCourse(null);
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>Student Dashboard</h3>
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item>
              <Box
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  borderRadius: 8,
                  padding: "12px 24px",
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <Typography
                  variant="h5"
                  style={{ color: "#fff", marginRight: 16 }}
                >
                  {window.localStorage.getItem("x-auth-fullname") || "Student"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs />
            <Grid item>
              <Button variant="contained" color="primary">
                Reports
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Grid container spacing={2} alignItems="stretch">
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "stretch",
                minHeight: 450,
              }}
            >
              <SuccessProgress />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "stretch",
                minHeight: 450,
              }}
            >
              <CourseGroups />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Grid container spacing={2} alignItems="stretch">
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "stretch",
                minHeight: 450,
              }}
            >
              <OpenCourses />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "stretch",
                minHeight: 450,
              }}
            >
              <RequiredCourses studentId={studentId} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Grid container spacing={2} alignItems="stretch">
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 300,
              }}
            >
              <TermGrades />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 300,
              }}
            >
              <ClassNotices />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={modalOpen}
        onClose={handleModalClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{selectedCourse}</DialogTitle>
        <DialogContent>
          {selectedCourse && (
            <div>
              <Typography variant="body1">
                <strong>Description:</strong>{" "}
                {courseDetails[selectedCourse]?.description || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Prerequisites:</strong>{" "}
                {courseDetails[selectedCourse]?.prerequisites || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Sections:</strong>
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>CRN</TableCell>
                    <TableCell>Seats</TableCell>
                    <TableCell>Days</TableCell>
                    <TableCell>Time</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(courseDetails[selectedCourse]?.sections || []).map(
                    (section, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{section.crn}</TableCell>
                        <TableCell>{section.seats}</TableCell>
                        <TableCell>{section.days}</TableCell>
                        <TableCell>{section.time}</TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleModalClose}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StudentDashboard;
